import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const PriceListPage = () =>
  import('@modules/price/components/price-list-page.vue');
const PriceFormPage = () =>
  import('@modules/price/components/price-form-page.vue');
const PriceViewPage = () =>
  import('@modules/price/components/price-view-page.vue');
const PriceImporterPage = () =>
  import('@modules/price/components/price-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'price',
        path: '/price',
        component: PriceListPage,
        meta: {
          auth: true,
          permission: Permissions.values.priceView,
        },
      },
      {
        name: 'priceNew',
        path: '/price/new',
        component: PriceFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.priceCreate,
        },
      },
      {
        name: 'priceImporter',
        path: '/price/import',
        component: PriceImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.priceImport,
        },
      },
      {
        name: 'priceEdit',
        path: '/price/:id/edit',
        component: PriceFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.priceEdit,
        },
        props: true,
      },
      {
        name: 'priceView',
        path: '/price/:id',
        component: PriceViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.priceView,
        },
        props: true,
      },
    ],
  },
];
